<template>
  <div class="header">
    <van-row class="add-box" type="flex" justify="space-between">
      <van-col span="4" class="arrow-left">
        <div @click="back" v-if="!noLeft">
          <van-icon name="arrow-left" color="var(--text_color)" size="20" />
        </div>
      </van-col>
      <van-col span="16">
        <span>{{ totalName }}</span>
      </van-col>
      <van-col span="4" @click="goRouter" v-if="rightRouter&&rightTitle" class="rightTitle">{{ rightTitle }}</van-col>
      <van-col span="4" @click="goRouter" v-else>
        <svg-icon class-name="svgs" :icon-class="rightIco"  />
        </van-col>
    </van-row>
  </div>
</template>
<script>
import { routeStack } from '@/router'
export default {
  props: {
    totalName: {
      type: [String],
      default: ''
    },
    noLeft: {
      type: [Boolean],
      default: false
    },
    routerName: {
      type: String,
      default: ''
    },
    rightTitle: {
      type: String,
      default: ''
    },
    rightIco: {
      type: String,
      default: ''
    },
    rightRouter: {
      type: String,
      default: ''
    }
  },
  methods: {
    back() {
      if (this.routerName) {
        this.$router.replace({ name: this.routerName })
      } else if (routeStack.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.replace({ name: 'Home' })
      }
    },
    goRouter() {
      if (this.rightRouter) {
        this.$router.push({ name: this.rightRouter })
      }
    },
    handleClick() {
      this.$emit('clickRight')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/styles/mixin.styl'
.header
  background-color var(--background_color)
  position fixed
  left 0
  right 0
  top 0
  z-index 99
  font-size 15px
  font-weight bold
  font-style normal
  height 50px
  color var(--text_color)
  .van-col
    height 50px
    flex-center()
  .rightTitle
    font-size 13px
  .svgs
    width: 17px;
    height: 17px;
    color: var(--text_color);
  .arrow-left
    justify-content flex-start
    padding-left 15px
</style>
